import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const ClassNotebookLogoInverseIcon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M64 272L1216 67v1914L64 1782V272zm280 1090l108 6V991q0-33 1-67t-1-68l290 528 145 9V635l-136 8v508L482 659l-138 6v697zm1660-97q17 0 30 13t14 31v308q0 17-13 30t-31 14h-73v-396h73zm-12-861q23 0 39 16t17 40v282q0 20-14 33t-33 13h-102v925q0 23-17 40t-40 17h-562v-235h491v-85h-491v-107h491v-86h-491V276h551q28 0 42 12t20 32 6 42 0 42h93zm-184 245l-57-58 12-80-80-14-38-72-73 36-73-36-38 72-80 14 11 80-56 58 56 59-11 80 78 14 13 28v260l96-97 96 97V830l17-28 81-14-11-80 57-59zm-236-102q21 0 39 8t33 22 22 32 8 40q0 21-8 39t-22 33-32 22-40 8q-21 0-39-8t-33-22-22-32-8-40q0-21 8-39t22-33 32-22 40-8zm432 278q17 0 30 13t14 31v308q0 17-13 30t-31 14h-73V825h73z" />
    </svg>
  ),
  displayName: 'ClassNotebookLogoInverseIcon',
});

export default ClassNotebookLogoInverseIcon;
